import React from 'react';

export const DutchiePaySuccess = (props: any): JSX.Element => (
  <svg xmlns='http://www.w3.org/2000/svg' width='221' height='166' fill='none' {...props}>
    <path
      fill='#B0C4CC'
      d='M201.203 89.378v28.454h-6.134V45.415L166.85 30.198v25.23h-9.813v-17.63h-24.538v-9.571h6.848c.978-.018 1.759-.764 1.74-1.669v-5.062c.019-.905-.762-1.651-1.74-1.668h-6.848l-8.972-10.715-9.43 10.715h-8.074c-.98.017-1.759.763-1.742 1.668v5.06c-.017.905.762 1.651 1.742 1.669h8.074v23.68H96.92V41.426h4.909v-8.23H24.538v8.23h6.133v68.346l-8.588-.193V86.774L0 96.402v46.331h220.832V89.227l-19.629.15Z'
      opacity='.4'
    />
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M136.18 43.059c-4.742 0-8.587 3.806-8.587 8.503l17.174.002c0-4.697-3.845-8.505-8.587-8.505Zm-49.811 3.195H43.674v8.505H86.37v-8.505ZM6.133 102.58h11.042v6.074H6.133v-6.074Zm11.042 12.147H6.133v6.074h11.042v-6.074ZM6.133 126.874h11.042v6.074H6.133v-6.074Zm171.759-77.742h-4.907v10.933h4.907V49.132Zm4.907 0h4.909v10.933h-4.907l-.002-10.933Zm-4.907 18.223h-4.907v10.93h4.907v-10.93Zm4.907-2.432h4.909v10.933h-4.907l-.002-10.933Zm-4.907 13.43h-4.907v10.932h4.907V78.354Zm4.907 2.363h4.909v10.933h-4.907l-.002-10.933Zm-4.907 13.427h-4.907v10.933h4.907V94.143Zm4.907 2.364h4.909v10.933h-4.907l-.002-10.933Zm33.127-1.149h-9.816v6.074h9.816v-6.074Zm-9.816 12.148h9.816v6.073h-9.816v-6.073Zm9.816 12.147h-9.816v6.073h9.816v-6.073Zm-42.941-9.718h4.907v10.933h-4.907v-10.933Zm14.723 2.362h-4.909l.002 10.934h4.907v-10.934Z'
      clipRule='evenodd'
    />
    <path
      fill='#BDCCCE'
      d='M168.607 150.44H46.991c-17.357 0-25.547 1.254-25.547 2.793 0 1.541.763 3.508 20.638 3.508l13.608-.029v.029h73.832v-.046l44.535.046c22.029 0 22.877-1.958 22.877-3.504 0-1.547-9.081-2.797-28.323-2.797h-.004Z'
    />
    <path
      fill='#F1F0DE'
      d='M178.249 151.281v-74.49a4.199 4.199 0 0 0 3.636-4.128v-3.066l-11.817-13.11H49.508L37.69 69.597v3.066a4.215 4.215 0 0 0 4.23 4.189l.614 2.43v71.999'
    />
    <path fill='#D7D6C9' d='M42.94 77.136v4.206l133.726 1.87v-6.074L42.94 77.136Z' />
    <path
      fill='#405D67'
      fillRule='evenodd'
      d='M41.712 154.882h44.78v-.004c1.018 0 1.841-.816 1.841-1.823a1.83 1.83 0 0 0-1.84-1.821h-41.1V76.529a1.831 1.831 0 0 0-1.84-1.823c-1.016 0-1.84.818-1.84 1.823v78.353Zm92.628 0h44.78V76.53a1.832 1.832 0 0 0-1.84-1.822c-1.017 0-1.84.818-1.84 1.823v74.705h-41.1a1.831 1.831 0 0 0-1.841 1.821 1.834 1.834 0 0 0 1.841 1.825Z'
      clipRule='evenodd'
    />
    <path
      fill='#C0BFB2'
      d='M115.937 137.873a1.832 1.832 0 0 1-1.84-1.821v-14.577c0-1.005.823-1.822 1.84-1.822a1.83 1.83 0 0 1 1.84 1.822v14.575a1.83 1.83 0 0 1-1.84 1.823Z'
    />
    <path
      fill='#405D67'
      fillRule='evenodd'
      d='M96.92 154.882h26.992V103.86H96.92v51.022Zm23.312-3.646h-19.631v-43.732h19.631v43.732Z'
      clipRule='evenodd'
    />
    <path fill='#fff' d='M98.76 98.395h23.31v9.717H98.76v-9.717Z' />
    <path
      fill='#405D67'
      fillRule='evenodd'
      d='M96.92 109.935h26.992V96.572H96.92v13.363Zm23.312-3.643h-19.631v-6.076h19.631v6.076Z'
      clipRule='evenodd'
    />
    <path fill='#EAF0F2' d='M61.955 95.967h19.629v44.943H61.955V95.967Z' />
    <path
      fill='#405D67'
      fillRule='evenodd'
      d='M60.115 142.733h23.311V94.144H60.115v48.589Zm19.63-3.644h-15.95v-41.3h15.95v41.3Z'
      clipRule='evenodd'
    />
    <path fill='#EAF0F2' d='M43.552 95.967h18.403v44.943H43.552V95.967Z' />
    <path
      fill='#405D67'
      fillRule='evenodd'
      d='M41.712 142.733h22.083V94.144H41.712v48.589Zm18.403-3.644H45.393v-41.3h14.722v41.3Z'
      clipRule='evenodd'
    />
    <path fill='#EAF0F2' d='M158.877 95.967h18.403v44.943h-18.403V95.967Z' />
    <path
      fill='#405D67'
      fillRule='evenodd'
      d='M157.037 142.733h22.083V94.144h-22.083v48.589Zm18.403-3.644h-14.722v-41.3h14.722v41.3Z'
      clipRule='evenodd'
    />
    <path fill='#EAF0F2' d='M139.246 95.967h19.629v44.943h-19.629V95.967Z' />
    <path
      fill='#405D67'
      fillRule='evenodd'
      d='M137.406 142.733h23.311V94.144h-23.311v48.589Zm19.631-3.644h-15.95v-41.3h15.95v41.3Z'
      clipRule='evenodd'
    />
    <path
      fill='#D7D6C9'
      d='m104.764 93.536-6.004-4.423v-4.516l6.004-4.422h11.305l6.003 4.422v4.516l-6.003 4.423h-11.305Z'
    />
    <path fill='#405D67' d='M43.553 91.108h40.485v3.643a1.216 1.216 0 0 1-1.226 1.214h-39.26v-4.857Z' />
    <path
      fill='#405D67'
      fillRule='evenodd'
      d='M41.712 97.788h41.1v-.002c1.693 0 3.067-1.359 3.067-3.035v-5.466H41.712v8.503Zm40.486-3.644H45.393V92.93h36.805v1.215Z'
      clipRule='evenodd'
    />
    <path fill='#405D67' d='M136.794 91.108h40.486v4.857h-39.26a1.22 1.22 0 0 1-1.226-1.214v-3.643Z' />
    <path
      fill='#405D67'
      fillRule='evenodd'
      d='M138.02 97.788h41.1v-8.503h-44.166v5.466c.003.809.328 1.583.903 2.153.575.57 1.353.887 2.163.884Zm37.42-3.644h-36.806V92.93h36.806v1.215Z'
      clipRule='evenodd'
    />
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M52.453 105.685c9.492-7.29 3.594-8.504-7.08 1.214l.02 17.613c0 3.644 5.871.607 12.994-5.466 3.442-2.937 3.556-2.466 3.828-1.333.29 1.21.762 3.174 5.664 2.547 9.494-1.214 11.867-4.858 11.867-4.858v-4.86s-16.63 6.074-9.504-1.214c7.125-7.289 5.937-9.719-10.673 1.214-15.769 10.379-15.862 1.856-7.116-4.857Zm97.223 2.375c3.68-4.146 2.084-7.154-8.589-1.382v12.886c0 2.165 7.093.359 14.214-3.25 3.335-1.689 3.458-.114 3.622 1.964.185 2.359.422 5.368 5.469 4.984 5.335-.223 9.86-3.955 11.042-9.111v-2.886s-15.383 3.609-8.266-.721c6.257-3.802 3.365-7.024-10.673.721-11.728 6.47-14.058 4.953-6.819-3.205Z'
      clipRule='evenodd'
    />
    <path
      fill='#44A788'
      d='m84.775 131.802 7.147-7.29h-6.795l5.164-6.073h-5.939l-3.38-6.074-3.375 6.074h-5.939l5.165 6.073h-6.796l7.148 7.288H68.6l10.324 9.425a3.105 3.105 0 0 0 4.1 0l10.324-9.425h-8.572l-.001.002Z'
    />
    <path
      fill='#B2B19F'
      fillRule='evenodd'
      d='M145.383 142.128h-14.726v10.927h14.726v-10.927Zm-57.662 0H72.995v9.711H87.72v-9.711Z'
      clipRule='evenodd'
    />
    <path
      fill='#979797'
      d='M130.657 142.128v-.417h-.416v.417h.416Zm14.726 0h.417v-.417h-.417v.417Zm-14.726 10.927h-.416v.417h.416v-.417Zm14.726 0v.417h.417v-.417h-.417Zm-72.388-10.927v-.417h-.417v.417h.417Zm14.726 0h.416v-.417h-.416v.417Zm-14.726 9.711h-.417v.417h.417v-.417Zm14.726 0v.417h.416v-.417h-.416Zm42.936-9.295h14.726v-.833h-14.726v.833Zm.417 10.511v-10.927h-.833v10.927h.833Zm14.309-.416h-14.726v.833h14.726v-.833Zm-.416-10.511v10.927h.833v-10.927h-.833Zm-71.972.416H87.72v-.833H72.995v.833Zm.416 9.295v-9.711h-.833v9.711h.833Zm14.31-.416H72.995v.833H87.72v-.833Zm-.417-9.295v9.711h.833v-9.711h-.833Z'
    />
    <path
      fill='#405D67'
      fillRule='evenodd'
      d='M76.826 154.882h7.677v-.002a4.473 4.473 0 0 0 4.494-3.443l2.875-12.348H69.458l2.859 12.269a4.488 4.488 0 0 0 4.51 3.524Zm-.904-4.262-1.84-7.887H87.246l-1.846 7.962a.871.871 0 0 1-.89.541h-7.678a.872.872 0 0 1-.91-.616Z'
      clipRule='evenodd'
    />
    <path
      fill='#44A788'
      d='m142.437 131.802 7.148-7.29h-6.796l5.163-6.073h-5.937l-3.381-6.074-3.376 6.074h-5.935l5.164 6.073h-6.797l7.147 7.288h-8.575l10.325 9.425a3.105 3.105 0 0 0 4.099 0l10.325-9.425h-8.574v.002Z'
    />
    <path
      fill='#405D67'
      fillRule='evenodd'
      d='M134.489 154.882h7.677v-.002a4.473 4.473 0 0 0 4.494-3.443l2.873-12.348H127.12l2.857 12.269a4.489 4.489 0 0 0 4.512 3.524Zm-.905-4.262-1.84-7.887h13.17l-1.851 7.962a.873.873 0 0 1-.892.541h-7.676a.871.871 0 0 1-.911-.616ZM36.805 70.457l12.268-13.97h121.458l12.268 13.97v2.44a4.273 4.273 0 0 1-4.281 4.24H41.088a4.273 4.273 0 0 1-4.283-4.24v-2.44Zm23.851 71.745c.346.342.813.533 1.3.531 1.016 0 1.84-.816 1.84-1.823V95.965a1.83 1.83 0 0 0-1.84-1.82c-1.016 0-1.841.815-1.841 1.822v44.943c.001.485.196.95.541 1.292Z'
      clipRule='evenodd'
    />
    <path fill='#677F86' d='M173.723 67.42H45.881l6.257-7.287H167.47l6.253 7.288Z' />
    <path
      fill='#405D67'
      fillRule='evenodd'
      d='M160.718 94.144h-3.681v46.161h3.681v-46.16Zm-84.04 60.738h67.477v-.002c1.015 0 1.84-.816 1.84-1.823a1.832 1.832 0 0 0-1.84-1.821H76.677c-1.015 0-1.84.816-1.84 1.821a1.832 1.832 0 0 0 1.84 1.825Z'
      clipRule='evenodd'
    />
  </svg>
);
